const KeenSlider = window.KeenSlider
const { setInitialised, useArrows, addWheelControls } =
  window.BAO.Carousel.plugins

class ProductTechGlossary extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.carousel = this.setupCarousel()
  }

  setupCarousel () {
    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500,
        },
        loop: false,
        mode: 'snap',
        slides: {
          perView: 'auto',
          spacing: 16,
        },
        breakpoints: {
          '(min-width: 901px)': {
            slides: {
              perView: 'auto',
              spacing: 32,
            },
          },
        },
      },
      [
        setInitialised(),
        useArrows({
          next: this.els?.next?.element,
          previous: this.els?.previous?.element,
        }),
        addWheelControls('horizontal'),
      ],
    )
  }
}

if (!customElements.get('product-tech-glossary')) {
  customElements.define('product-tech-glossary', ProductTechGlossary)
}
